import { render, staticRenderFns } from "./UserAddresses.vue?vue&type=template&id=2e258082&scoped=true&"
import script from "./UserAddresses.vue?vue&type=script&lang=js&"
export * from "./UserAddresses.vue?vue&type=script&lang=js&"
import style0 from "./UserAddresses.vue?vue&type=style&index=0&id=2e258082&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e258082",
  null
  
)

export default component.exports